import React, {useEffect, useState, PropsWithChildren} from 'react';
import {RootStoreType, useStore} from '@/store/root-store';
import {setHasRegisteredIntoStorage} from '@/api/common-utils';
import {useRouter} from 'next/navigation';
import {isProtectedPath} from '@/utils/subscription';
import {MainLoader} from '@/components/common-components/v2/MainLoader';
import {notification} from '@/utils/notification-v2';

type IProps = PropsWithChildren<{
  store: RootStoreType;
}>;

const withAuthentication = (WrappedComponent: React.FC<any>) => {
  const RequiresAuthentication = (props: IProps) => {
    const router = useRouter();
    const {settings: {customer: {profile}}} = useStore('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
      // if (!router.isReady) return;
      const fetchProfile = async () => {
        // this is used by masquerade feature.
        // eslint-disable-next-line camelcase

        try {
          // Check for protected paths and if this customer has access to those
          // paths, and redirect to /404 if doesn't have access rights.
          if (profile?.subscription) {
            const {isProtected, productFlag} = isProtectedPath(location.pathname);
            if (isProtected && !profile?.subscription[productFlag]) {
              router.push('/404');
            }
          }
          setIsAuthenticated(true);
          setHasRegisteredIntoStorage();
        } catch (error) {
          if (error?.response?.status === 429) {
            notification.error('', 'You’re currently out of quota. Please upgrade your plan to Optimize this Page.');
          }
        }
      };
      fetchProfile();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router]);

    return isAuthenticated ? <WrappedComponent {...props} /> : <MainLoader fullPage={true} />;
  };

  return RequiresAuthentication;
};

export default withAuthentication;
